module.exports = __webpack_public_path__ + "static/media/network-logo.3f6742c1.png";